module.exports = require('next/compat/router');
